import styled from 'styled-components';

const SaveButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 20px;
`;

export {
  SaveButtonContainer,
};
